// extracted by mini-css-extract-plugin
export default {"container":"tabs__container___1c_sF"};